import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { TasksFiles } from 'modules/tasks/store/collections/tasks_files'
import TaskFile from 'modules/tasks/store/models/TaskFile'

export const useFormTaskFiles = () => {
  const currentFiles = useLazyRef(() => new TasksFiles([])).current
  const newFiles = useLazyRef(() => new TasksFiles([])).current
  const removeFiles = useLazyRef(() => new TasksFiles([])).current

  const onDropFiles = async (files: File[]) => {
    const newTaskFiles = files.map(
      (file) =>
        new TaskFile({
          filename: file.name,
          file: file,
        })
    )
    newFiles.add(newTaskFiles)
  }

  const onDeleteNewFile = (file: TaskFile) => newFiles.remove(file)

  const onDeleteExistingFile = (file: TaskFile) => {
    removeFiles.add(file)
    currentFiles.remove(file.id)
  }

  return {
    currentFiles,
    newFiles,
    removeFiles,
    onDropFiles,
    onDeleteNewFile,
    onDeleteExistingFile,
  }
}
